import React from 'react';
import style from './Footer.module.scss';
const Footer = () => {
  return (
    <div className={style.Footer}>
      <p>&copy;2019 Fluxo</p>
    </div>
  );
};

export default Footer;
